import { Children, type ReactNode } from 'react'

import { cn } from '@/lib/utils'

type EntityContactStripProps = {
  children: ReactNode
  className?: string
}

/** Inline contact links, packed left. Each link stays whole and wraps to the next line when it does not fit. */
export function EntityContactStrip({ children, className }: EntityContactStripProps) {
  const items = Children.toArray(children)
  if (items.length === 0) return null

  return (
    <div className={cn('flex flex-wrap items-center gap-x-4 gap-y-2', className)}>
      {items}
    </div>
  )
}
